export const scrollToAnchor = (href: string) => {
  if (href?.startsWith('#')) {
    const id = href.substring(1);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });

      if (window.history.replaceState) {
        // Drop the `#anchor` from the URL after scrolling, but keep the query
        // string: `location.pathname` alone would discard `?utm_*`, wiping the
        // campaign attribution that Munchkin/GTM/Dreamdata read on form submit.
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }
    }
  }
};
